module.exports = __webpack_public_path__ + "img/pages.d7866f3f.svg";